import React, { useEffect, useState } from "react";
import * as func from "../../common/athleteCommon/FunctionCalls";
import Select from "react-select";

interface Props {
    formData: any;
    onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
}

const BasicMedicalProfile: React.FC<Props> = ({ formData, onChange }) => {

    // const bldGrpLst = [{ bldGrpId: 1, bldGrpName: "A+" }, { bldGrpId: 2, bldGrpName: "A-" }, { bldGrpId: 3, bldGrpName: "B+" }, { bldGrpId: 4, bldGrpName: "B-" }, { bldGrpId: 5, bldGrpName: "O+" }, { bldGrpId: 6, bldGrpName: "O-" }, { bldGrpId: 7, bldGrpName: "AB+" }, { bldGrpId: 8, bldGrpName: "AB-" }]
    // const tbcoHstryLst = [{ tbcoHstryId: 1, tbcoHstry: "Never Smoked" }, { tbcoHstryId: 2, tbcoHstry: "Smoked but gave up" }, { tbcoHstryId: 3, tbcoHstry: "Smoke Ocassionally" }, { tbcoHstryId: 4, tbcoHstry: "Smoke Daily" }]
    // const alchlHstryLst = [{ alchlHstryId: 1, alchlHstry: "Never Consumed Alcohol" }, { alchlHstryId: 2, alchlHstry: "Have consumed in past but no longer" }, { alchlHstryId: 3, alchlHstry: "Drink Occasionally" }, { alchlHstryId: 4, alchlHstry: "Drink Often" }]

    const [bldGrpLst, setBldGrpLst] = useState<any[]>([]);
    const [tbcoHstryLst, setTbcoHstryLst] = useState<any[]>([]);
    const [alchlHstryLst, setAlchlHstryLst] = useState<any[]>([]);

    useEffect(() => {
        async function getBasicMedProfile() {
            const bldResponse = await func.bloodGroup(null);
            setBldGrpLst(Array.isArray(bldResponse) ? bldResponse : []);
            const tobacoResponse = await func.tobacco(null);
            setTbcoHstryLst(Array.isArray(tobacoResponse) ? tobacoResponse : [])
            const alcResponse = await func.alcohol(null);
            setAlchlHstryLst(Array.isArray(alcResponse) ? alcResponse : [])
        }
        getBasicMedProfile();
    }, [])

    const handleSelectChange = (name: string) =>
        (option: any) => {
            const value = Array.isArray(option)
                ? option.map(o => o.value)
                : option?.value ?? "";

            onChange({
                target: { name, value }
            } as React.ChangeEvent<HTMLInputElement>);
        };

    return (
        <>
            <div className="card-tableset" style={{ padding: "10px" }}>
                <div className="card-body">
                    <div className="row">
                        <div className="col-lg-4">
                            <h4>Is there no medical history?</h4>
                        </div>
                        <div className="col-lg-2">
                            <div className="form-check form-switch d-flex align-items-center justify-content-start">
                                <input
                                    className="form-check-input text-end"
                                    type="checkbox"
                                    checked={formData.noHistory === '1'}
                                    name="noHistory"
                                    // onChange={onChange}
                                    onChange={(e) =>
                                        onChange({
                                            target: {
                                                name: "noHistory",
                                                value: e.target.checked ? "1" : "0"
                                            }
                                        } as React.ChangeEvent<HTMLInputElement>)
                                    }
                                />
                            </div>
                        </div>
                    </div>
                    {(formData.noHistory != "1") ?
                        <>
                            <div className="row">
                                <div className="col-lg-4">
                                    <label className="form-label">Blood Group</label>
                                    <Select
                                        value={bldGrpLst.find(bld => bld.bloodGroupId === formData.bloodGroup) ? {
                                            value: formData.bloodGroup,
                                            label: bldGrpLst.find(bld => bld.bloodGroupId === formData.bloodGroup)?.name
                                        } : null}
                                        onChange={handleSelectChange("bloodGroup")}
                                        required
                                        placeholder="Select Blood Group"
                                        options={bldGrpLst.map(bld => ({
                                            value: bld.bloodGroupId,
                                            label: bld.name
                                        }))}>
                                    </Select>
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Tobacco Usage History</label>
                                    <Select
                                        value={tbcoHstryLst.find(tbc => tbc.tobaccoUsageId === formData.tobaccoUsageHistory) ? {
                                            value: formData.tobaccoUsageHistory,
                                            label: tbcoHstryLst.find(tbc => tbc.tobaccoUsageId === formData.tobaccoUsageHistory)?.name
                                        } : null}
                                        onChange={handleSelectChange("tobaccoUsageHistory")}
                                        required
                                        placeholder="Select Tobacco Usage"
                                        options={tbcoHstryLst.map(tbc => ({
                                            value: tbc.tobaccoUsageId,
                                            label: tbc.name
                                        }))}>
                                    </Select>
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Alcohol Usage History</label>
                                    <Select
                                        value={alchlHstryLst.find(alc => alc.alcoholUsageId === formData.alcoholHistory) ? {
                                            value: formData.alcoholHistory,
                                            label: alchlHstryLst.find(alc => alc.alcoholUsageId === formData.alcoholHistory)?.name
                                        } : null}
                                        onChange={handleSelectChange("alcoholHistory")}
                                        required
                                        placeholder="Select Alcohol Usage"
                                        options={alchlHstryLst.map(alc => ({
                                            value: alc.alcoholUsageId,
                                            label: alc.name
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <label className="form-label">Relevant Family Medical History</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                    name="relevantFamilyMedicalHistory"
                                    value={formData.relevantFamilyMedicalHistory}
                                    onChange={onChange}
                                    placeholder="Enter Medical Condition" />
                            </div>
                        </> : null}
                </div>
            </div>
            {/* </div > */}
        </>
    );
};

export default BasicMedicalProfile;